module.exports = "<pplus-meter-totalizer></pplus-meter-totalizer>\r\n"